import React from "react";

const SeoFields = ({
  formData,
  setFormData,
  handleChange,
  errors = {},
  backendErrors = {},
}) => {
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64Image = reader.result;

      setFormData((prev) => ({
        ...prev,
        metaImage: base64Image,
        metaImagePreview: base64Image,
      }));
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-header fw-bold bg-light">SEO Information</div>

      <div className="card-body">
        {backendErrors?.message && (
          <div className="alert alert-danger">{backendErrors.message}</div>
        )}
        <div className="row g-3">
          {/* Meta Title */}
          <div className="col-md-12">
            <label className="form-label">
              Meta Title <span className="text-danger">*</span>
            </label>

            <input
              type="text"
              name="metaTitle"
              readOnly
              className={`form-control ${
                errors.metaTitle || backendErrors?.metaTitle ? "is-invalid" : ""
              }`}
              value={formData?.metaTitle || ""}
              onChange={handleChange}
            />

            <div className="d-flex justify-content-between align-items-center mt-1">
              {(errors.metaTitle || backendErrors?.metaTitle) && (
                <div className="text-danger small">
                  {errors.metaTitle || backendErrors?.metaTitle}
                </div>
              )}

              <small className="fw-semibold ms-auto">
                {formData?.metaTitle?.length || 0}/60
              </small>
            </div>
          </div>

          {/* Meta Keywords */}
          <div className="col-md-12">
            <label className="form-label">Meta Keywords</label>

            <input
              type="text"
              name="metaKeywords"
              className={`form-control ${
                errors.metaKeywords || backendErrors?.metaKeywords
                  ? "is-invalid"
                  : ""
              }`}
              value={formData?.metaKeywords || ""}
              onChange={handleChange}
              placeholder="keyword1, keyword2"
            />

            {(errors.metaKeywords || backendErrors?.metaKeywords) && (
              <div className="invalid-feedback d-block">
                {errors.metaKeywords || backendErrors?.metaKeywords}
              </div>
            )}
          </div>

          {/* Meta Description */}
          <div className="col-md-12">
            <label className="form-label">
              Meta Description
              <span className="text-danger">*</span>
            </label>

            <textarea
              rows={4}
              name="metaDescription"
              className={`form-control ${
                errors.metaDescription || backendErrors?.metaDescription
                  ? "is-invalid"
                  : ""
              }`}
              value={formData?.metaDescription || ""}
              readOnly
              onChange={handleChange}
            />

            <div className="d-flex justify-content-between align-items-center mt-1">
              {(errors.metaDescription || backendErrors?.metaDescription) && (
                <div className="text-danger small">
                  {errors.metaDescription || backendErrors?.metaDescription}
                </div>
              )}

              <small className="fw-semibold ms-auto">
                {formData?.metaDescription?.length || 0}/100
              </small>
            </div>
          </div>

          {/* Meta Image */}
          <div className="col-md-6">
            <label className="form-label">
              Meta Image
            </label>

            <input
              type="file"
              accept="image/*"
              className={`form-control ${
                errors.metaImage || backendErrors?.metaImage ? "is-invalid" : ""
              }`}
              onChange={handleImageChange}
            />

            {(errors.metaImage || backendErrors?.metaImage) && (
              <div className="invalid-feedback d-block">
                {errors.metaImage || backendErrors?.metaImage}
              </div>
            )}

            {formData?.metaImagePreview && (
              <div className="mt-3">
                <img
                  src={formData.metaImagePreview}
                  alt="Meta Preview"
                  className="img-thumbnail"
                  width="150"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeoFields;
